module.exports = {
  isEmpty(obj) {
    return typeof obj === 'object' && Object.keys(obj).length === 0
  },
  fixUrl(url = '') {
    if (typeof url !== 'string' || !url.length) return url
    //Terribly hacky - strip and re-add to ensure propper url formatting
    const protocol = 'https://'
    const subdomain = 'www.'
    let urlFixed = url
    urlFixed = urlFixed.replace('http://', protocol)
    urlFixed = urlFixed.replace(protocol, '')
    urlFixed = urlFixed.replace(subdomain, '')
    urlFixed = protocol + subdomain + urlFixed
    return urlFixed
  },
  getDatesWithinRange(startDate, endDate, withTime = false) {
    // Returns an array of dates between the two dates
    const dates = []
    //test if is in date obj, for now we know its not
    startDate = new Date(startDate)
    endDate = new Date(endDate)
    let currentDate = startDate
    const addDays = function (days) {
      const date = new Date(this.valueOf())
      date.setDate(date.getDate() + days)
      return date
    }
    while (currentDate <= endDate) {
      if (!withTime) {
        const dateFixed = currentDate.toISOString().split('T')[0]
        dates.push(dateFixed)
      } else {
        dates.push(currentDate)
      }
      currentDate = addDays.call(currentDate, 1)
    }
    return dates
  },
  humanDate(datetime, withYear = true, useKeywords = true) {
    const dt = toDateClass(datetime)
    const month = (dt.getMonth() + 1).toString().padStart(2, '0')
    const day = dt.getDate().toString().padStart(2, '0')
    const year = dt.getFullYear()
    const date = `${month}/${day}`
    const dateWithYear = `${month}/${day}/${year}`
    if (useKeywords) {
      return dateKeyword(dateWithYear)
    }
    return withYear ? dateWithYear : date
  },
  humanTime(datetime, isMilitary = false) {
    const dt = toDateClass(datetime)
    let hours = dt.getHours()
    const minutes = dt.getMinutes().toString().padStart(2, '0')
    if (isMilitary) {
      return `${hours}:${minutes}`
    }
    const period = hours >= 12 ? 'PM' : 'AM'
    hours = hours > 12 ? hours - 12 : hours
    return `${hours}:${minutes}${period}`
  },
  ordinalFromNumber(n) {
    let ord = 'th'
    const num = parseInt(n)
    if (num % 10 == 1 && num % 100 != 11) {
      ord = 'st'
    } else if (num % 10 == 2 && num % 100 != 12) {
      ord = 'nd'
    } else if (num % 10 == 3 && num % 100 != 13) {
      ord = 'rd'
    }

    return ord
  },
  monthFromDate(datetime, abbreviation = false) {
    const dt = toDateClass(datetime)
    const mth = dt.getMonth()
    const lngth = abbreviation ? 'short' : 'long'
    const monthMap = [
      { short: 'Jan', long: 'January' },
      { short: 'Feb', long: 'February' },
      { short: 'Mar', long: 'March' },
      { short: 'Apr', long: 'April' },
      { short: 'May', long: 'May' },
      { short: 'Jun', long: 'June' },
      { short: 'Jul', long: 'July' },
      { short: 'Aug', long: 'August' },
      { short: 'Sept', long: 'September' },
      { short: 'Oct', long: 'October' },
      { short: 'Nov', long: 'November' },
      { short: 'Dec', long: 'December' },
    ]
    return monthMap?.[mth]?.[lngth] || ''
  },
  roundNum(num, places = 2) {
    return parseFloat(
      num.toLocaleString('en', {
        maximumFractionDigits: places,
        useGrouping: false,
      }),
    )
  },
  timeout(ms = 1000) {
    return new Promise((res) => {
      setTimeout(() => res(), ms)
    })
  },
}
